import { EventType, handleEvent } from "./base";

export const handleFilterEvent = (
  outcomeAreaName: string,
  isAdding: boolean,
) => {
  handleEvent(EventType.Filter, {
    domainName: outcomeAreaName,
    action: isAdding ? "apply_filter" : "remove filter",
  });
};
